/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetProjectsOptions, GetProjectsResponses } from '../types/GetProjects'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/}
 */
export function getProjects<ThrowOnError extends boolean = true>(options: Options<GetProjectsOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetProjectsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/projects/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetProjectsResponses, ThrowOnError>>)
}
